import React from 'react';
import { isSalesConversationFlow } from '../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import AddressInputComponent from './AddressInputComponent';
import DriverAddressInputComponent from './DriverAddressInputComponent';

interface Props {
  question: FlowsQuestion;
}

const AddressInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  ...props
}) => {
  const simpleAddressInputGroups = ['DRIVER', 'CAR'];

  if (
    simpleAddressInputGroups.includes(question.tag || '') &&
    isSalesConversationFlow()
  ) {
    return <DriverAddressInputComponent question={question} />;
  }
  return <AddressInputComponent question={question} {...props} />;
};

export default AddressInputPicker;
